<template>
  <q-page class="q-pa-md bg-grey-2">
    <!-- NAVEGACIÓN Y BREADCRUMBS -->
    <div class="row items-center justify-between q-mb-md wrap gap-sm">
      <q-breadcrumbs active-color="primary" style="font-size: 14px" class="q-py-xs">
        <q-breadcrumbs-el label="Inicio" icon="home" to="/aveo/Dashboard" />
        <q-breadcrumbs-el label="Tipo de Cambio" icon="currency_exchange" />
      </q-breadcrumbs>

      <q-btn
        color="primary"
        icon="add"
        label="Agregar Cambio"
        no-caps
        unelevated
        class="text-weight-bold"
        @click="AbrirNuevoTipoCambio('')"
      />
    </div>

    <!-- Banner Header -->
    <q-card class="q-mb-md shadow-2 rounded-borders overflow-hidden">
      <div class="bg-primary text-white q-pa-md row items-center justify-between wrap">
        <div class="row items-center q-py-xs">
          <q-icon name="currency_exchange" size="md" class="q-mr-sm" />
          <div>
            <div class="text-h6 text-weight-bold">Tipos de Cambio por Mes</div>
            <div class="text-caption text-blue-2">Consulta y mantenimiento de tipos de cambio de moneda</div>
          </div>
        </div>
      </div>

      <!-- Filtro Mes y Año -->
      <q-card-section class="q-pa-md bg-white">
        <div class="row q-col-gutter-md items-center">
          <div class="col-12 col-sm-4">
            <q-select
              v-model="mes"
              :options="meses"
              option-value="idmes"
              option-label="nombremes"
              emit-value
              map-options
              label="Mes"
              outlined
              dense
            />
          </div>
          <div class="col-12 col-sm-4">
            <q-select
              v-model="anio"
              :options="anios"
              option-value="id"
              option-label="nombre"
              emit-value
              map-options
              label="Año"
              outlined
              dense
            />
          </div>
          <div class="col-12 col-sm-4">
            <q-btn
              color="primary"
              icon="search"
              label="Buscar Mes"
              class="full-width text-weight-bold"
              unelevated
              @click="Listar"
            />
          </div>
        </div>
      </q-card-section>
    </q-card>

    <!-- Tabla Quasar -->
    <q-card class="shadow-2 rounded-borders">
      <q-table
        :data="ListaArticulos"
        :columns="columns"
        row-key="FechaCambio2"
        :grid="$q.screen.xs"
        :pagination.sync="pagination"
        :rows-per-page-options="[10, 25, 50, 0]"
        flat
        bordered
        no-data-label="No hay registros de tipo de cambio para este mes"
      >
        <!-- Slot Grid para Móviles (Pantallas Celular) -->
        <template v-slot:item="props">
          <div class="q-pa-xs col-xs-12 col-sm-6">
            <q-card class="shadow-2 rounded-borders overflow-hidden bg-white">
              <q-card-section class="bg-grey-2 q-pa-sm row items-center justify-between">
                <div class="row items-center">
                  <q-icon name="event" color="primary" class="q-mr-xs" size="18px" />
                  <span class="text-subtitle1 text-weight-bold text-dark">{{ props.row.FechaCambio2 }}</span>
                </div>
                <q-chip color="primary" text-color="white" dense class="text-weight-bold">
                  {{ props.row.IdMoneda || 'USD' }}
                </q-chip>
              </q-card-section>

              <q-separator />

              <q-card-section class="q-pa-md">
                <div class="row q-col-gutter-sm text-center">
                  <div class="col-6">
                    <div class="text-caption text-grey-7 text-uppercase text-weight-bold">Compra</div>
                    <div class="text-h6 text-weight-bolder text-positive">S/ {{ props.row.Compra }}</div>
                  </div>
                  <div class="col-6 border-left">
                    <div class="text-caption text-grey-7 text-uppercase text-weight-bold">Venta</div>
                    <div class="text-h6 text-weight-bolder text-primary">S/ {{ props.row.Venta }}</div>
                  </div>
                </div>
              </q-card-section>

              <q-separator />

              <q-card-actions class="row q-col-gutter-xs justify-end bg-grey-1 q-pa-xs">
                <div class="col-6">
                  <q-btn
                    outline
                    color="positive"
                    icon="edit"
                    label="Editar"
                    no-caps
                    dense
                    class="full-width text-weight-bold bg-white"
                    @click="EditarCambio(props.row)"
                  />
                </div>
                <div class="col-6">
                  <q-btn
                    outline
                    color="primary"
                    icon="content_copy"
                    label="Duplicar"
                    no-caps
                    dense
                    class="full-width text-weight-bold bg-white"
                    @click="DuplicarCambio(props.row)"
                  />
                </div>
              </q-card-actions>
            </q-card>
          </div>
        </template>

        <!-- Columna Acciones (Vista Escritorio) -->
        <template v-slot:body-cell-Acciones="props">
          <q-td :props="props" class="text-right">
            <q-btn
              flat
              round
              color="positive"
              icon="edit"
              size="sm"
              @click="EditarCambio(props.row)"
            >
              <q-tooltip>Editar Tipo de Cambio</q-tooltip>
            </q-btn>
            <q-btn
              flat
              round
              color="negative"
              icon="content_copy"
              size="sm"
              @click="DuplicarCambio(props.row)"
            >
              <q-tooltip>Duplicar Tipo de Cambio</q-tooltip>
            </q-btn>
          </q-td>
        </template>
      </q-table>
    </q-card>

    <tipo-cambio-modal
      :DiaMes="DiaMes"
      :compra="compra"
      :venta="venta"
      :Nuevo="Nuevo"
      @CerrarModal="CerrarModalNuevoTipoCambio"
      :DialogServicio="DialogServicio"
    />
  </q-page>
</template>

<script>
import axios from "axios";
import TipoCambioModal from "@/pages/Cambio/CambioNuevo";

export default {
  components: { TipoCambioModal },
  data() {
    return {
      NumerosPaginas: 1,
      TotalPaginas: 0,
      TamanoPagina: 50,
      pagination: { rowsPerPage: 50 },
      DialogServicio: false,
      Buscar1: "",
      ListaArticulos: [],
      DiaMes: "",
      Nuevo: true,
      compra: "",
      venta: "",
      mes: new Date().toISOString().substr(5, 2),
      anio: new Date().toISOString().substr(0, 4),
      meses: [
        { idmes: "01", nombremes: "Enero" },
        { idmes: "02", nombremes: "Febrero" },
        { idmes: "03", nombremes: "Marzo" },
        { idmes: "04", nombremes: "Abril" },
        { idmes: "05", nombremes: "Mayo" },
        { idmes: "06", nombremes: "Junio" },
        { idmes: "07", nombremes: "Julio" },
        { idmes: "08", nombremes: "Agosto" },
        { idmes: "09", nombremes: "Setiembre" },
        { idmes: "10", nombremes: "Octubre" },
        { idmes: "11", nombremes: "Noviembre" },
        { idmes: "12", nombremes: "Diciembre" },
      ],
      anios: [
        { id: "2020", nombre: "2020" },
        { id: "2021", nombre: "2021" },
        { id: "2022", nombre: "2022" },
        { id: "2023", nombre: "2023" },
        { id: "2024", nombre: "2024" },
        { id: "2025", nombre: "2025" },
        { id: "2026", nombre: "2026" },
      ],
      columns: [
        { name: "IdMoneda", label: "Moneda", field: "IdMoneda", align: "left" },
        { name: "FechaCambio2", label: "Fecha", field: "FechaCambio2", align: "center", sortable: true },
        { name: "Compra", label: "Compra", field: "Compra", align: "right" },
        { name: "Venta", label: "Venta", field: "Venta", align: "right" },
        { name: "Acciones", label: "Acciones", field: "Acciones", align: "right" },
      ],
    };
  },
  created() {
    this.Listar();
  },
  methods: {
    AbrirNuevoTipoCambio(fecha) {
      this.DialogServicio = true;
      this.DiaMes = fecha;
      this.compra = "";
      this.venta = "";
      this.Nuevo = true;
    },
    CerrarModalNuevoTipoCambio() {
      this.DialogServicio = false;
      this.Listar();
    },
    EditarCambio(row) {
      this.Nuevo = false;
      this.DialogServicio = true;
      this.DiaMes = row.FechaCambio2;
      this.compra = row.Compra;
      this.venta = row.Venta;
    },
    DuplicarCambio(row) {
      this.DialogServicio = true;
      var fecha = new Date(row.FechaCambio2);
      fecha.setDate(fecha.getDate() + 2);
      this.DiaMes =
        fecha.getFullYear() +
        "-" +
        String(fecha.getMonth() + 1).padStart(2, '0') +
        "-" +
        String(fecha.getDate()).padStart(2, '0');
      this.venta = row.Venta;
      this.compra = row.Compra;
      this.Nuevo = true;
    },
    Listar() {
      let me = this;
      axios
        .get(
          "https://aveoperu.com/dniconsulta/CambioMes.php?mes=" +
            me.mes +
            "&anio=" +
            me.anio
        )
        .then(function(response) {
          if (response.data.success == true) {
            me.ListaArticulos = response.data.data;
          } else {
            me.ListaArticulos = [];
          }
        })
        .catch(function(error) {
          console.error(error);
        });
    },
  },
};
</script>
